import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";
import { FIREBASE_CONFIG } from "configs/AppConfig";

// Initialize Firebase App
const app = initializeApp(FIREBASE_CONFIG);

// Safely get Firebase Cloud Messaging instance (prevents crashes in unsupported browsers)
export const getFcmMessaging = async () => {
  try {
    if (typeof window !== "undefined" && "serviceWorker" in navigator) {
      const supported = await isSupported();
      if (supported) {
        return getMessaging(app);
      }
    }
  } catch (error) {
    console.error("Failed to initialize FCM Messaging:", error);
  }
  return null;
};
